<template>
    <div>
        <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">盘点单信息</div>
        <table class="simple-tbl"
               style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3"
                    style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>基本信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点单名称</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">{{ voucher.title }}</div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点单号</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.innerNo }}</span>
                            <el-tag type="primary" v-if="voucher.spotFlag">抽盘</el-tag>
                            <el-tag type="primary" v-if="voucher.quickFlag">快盘</el-tag>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘点方式</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.openMode">明盘</span>
                            <span v-else>暗盘</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">盘点部门全称

                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.retailerComFullName }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;"><span>自盘负责人</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <sapn>{{ voucher.principalName }}</sapn>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>自盘负责人是否确认</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.confirmed">已确认</span>
                            <span v-else>未确认</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建机构
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.creatorComName }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>抽盘负责人</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.spotPrincipalName }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>抽盘负责人是否确认</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="!voucher.spotFlag"></span>
                            <span v-else-if="voucher.spotConfirmed">已确认</span>
                            <span v-else>未确认</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>状态</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span v-if="voucher.state == 0">未开始</span>
                            <span v-if="voucher.state == 1">已开始</span>
                            <span v-if="voucher.state == 2">已结束</span>
                            <span v-if="voucher.state == -1">已取消</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>开始时间</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.startTime }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">结束时间
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.endTime }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">取消时间
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.cancelTime }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建时间
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.createTime }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">创建人
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.creatorName }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">需负责人签字
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.principalSigRequired ? '是' : '否' }}</span>
                        </div>
                    </div>
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span></span>
                        </div>
                    </div>
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span></span>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <table class="simple-tbl"
               style="width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 2px;border-color: gray;color: #666;font-size:12px; word-break:break-strict;">
            <tbody class="body">
            <tr class="row">
                <td colspan="3"
                    style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;text-align: center;color: #1a1a1a;font-weight: 600;background-color: #efefef;font-size: 12px;">
                    <span>盘点单统计信息</span>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>应盘条目数量</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;"><span>{{ voucher.totalCount }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>已盘条目数量</span></div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedCount }}</span>
                        </div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>未盘条目数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.totalCount - voucher.checkedCount }}</span>
                        </div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>资产数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.totalQuantity }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘盈数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedMoreQuantity }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘亏数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedLackQuantity }}</span></div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>损坏数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedFailQuantity || 0 }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>闲置数量</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.assetIdleXQuantity }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘亏净值(元)</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedLackNetWorth || 0 }}</span></div>
                    </div>
                </td>
            </tr>
            <tr class="row">
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>盘盈净值(元)</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <span>{{ voucher.checkedMoreNetWorth || 0 }}</span></div>
                    </div>
                </td>
                <td style="border: 1px solid #1a1a1a;vertical-align: middle;padding: 10px 4px;" v-if="voucher.principalSigDone">
                    <div class="info-item " style="overflow:hidden;">
                        <div class="label" style="width: 76px;float: left;color: #1a1a1a;font-weight: 600;white-space: normal;word-break: break-all;">
                            <span>签字结果</span>
                        </div>
                        <div class="value" style="padding-left: 76px;white-space: normal; word-break: break-all;">
                            <img :src="voucher.principalSigImgUrl" style="width: 100%"/>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <template>
            <div style="font-size: 15px; color: #1a1a1a; font-weight: 600; text-align: center; padding: 15px 0;">盘点明细</div>
            <table class="simple-tbl"
                   style="width: 100%; table-layout: fixed; border-collapse: collapse; border-spacing: 2px; border-color: gray; color: rgb(102, 102, 102); font-size: 12px;">
                <tbody class="body" style="margin-top: 10px">
                <tr class="row">
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>系统编号</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>名称</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>应盘数量</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>已盘数量</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>盘点结果</label>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="width: 76px; float: left; color: rgb(26, 26, 26); font-weight: 600; white-space: normal; word-break: break-all;">
                                <label>实物状态</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="row" v-for="item in voucher.itemList">
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                {{ item.tmpNo }}
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                {{ item.name || '' }}
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                {{ item.shouldQuantity || 0 }}
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                {{ item.checkedQuantity || 0 }}
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                <span>
                                    <span v-if="item.checkedFlag == 0" class="font-green">正常</span>
                                    <span v-if="item.checkedFlag == 1" class="font-red">盘盈</span>
                                    <span v-if="item.checkedFlag == -1" class="font-red" v-else>盘亏</span>
                                </span>
                            </div>
                        </div>
                    </td>
                    <td style="border: 1px solid rgb(26, 26, 26); vertical-align: middle; padding: 10px 4px;">
                        <div style="overflow: hidden;">
                            <div style="white-space: normal;word-break: break-all;color:#666666;word-wrap: break-word;">
                                <span>
                                    <span v-if="item.physicalState == 0" class="font-green">正常</span>
                                    <span v-else-if="item.physicalState == -1">无实物</span>
                                    <span class="font-red" v-else>损坏</span>
                                </span>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>
<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
//
import { showHtmlToPdfDlg } from '../ctrl/dialog'
//
import stockCheckApi from '../../api/stockCheck'

export default {
    name: 'swb-shop-device-stcok-check-voucher-for-pdf',
    desc: '盘点单导出',
    props: {
        voucherId: {
            type: Number,
            deafult: null,
        },
    },
    data: function () {
        return {
            voucher: {}
        }

    },
    created: function () {
        this.getShopDeviceStockCheckVoucher();
    },
    methods: {
        getShopDeviceStockCheckVoucher: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            let voucherId = self.voucherId;
            let postData = {
                id: voucherId,
                includeItems: true,
                includeCount: true
            }
            stockCheckApi.getShopDeviceStockCheckVoucher(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    self.voucher = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getHtml: function () {
            return this.$el.outerHTML;

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStockCheckVoucherForPdf.vue